module.exports = __webpack_public_path__ + "img/bg.4b904e08.png";